module.exports = __webpack_public_path__ + "static/media/Benin.c0cb89eb.png";